import {Component} from '@angular/core';
import {MensajeService} from '../Mensaje.Service';

import {Dialogo} from '../Modelo/Dialogo.model';
import {DialogoEnum, TipoOpcionEnum} from '../Enumeraciones/MensajeEnumeraciones.enum';


@Component(
  {
    selector: 'dialogo',
    templateUrl: './Dialogo.template.html',
    styleUrls: ['./Dialogo.scss'],
  })

export class DialogoComponent
{
  dialogo: Dialogo = new Dialogo();

  public animacion: string = "";
  public icono: string = "";
  public abierto: boolean = false;
  public TipoOpcionEnum = TipoOpcionEnum;
  public claseIcono : string = "";

  constructor(private dialogoService: MensajeService)
  {
  }

  ngOnInit()
  {
    this.dialogoService.IniciarDialogo().subscribe((dialogo: Dialogo) =>
    {
      this.dialogo = dialogo;

      this.AbrirDialogo();
    });
  }

  AbrirDialogo()
  {
    this.SetDatosDialogo(this.dialogo);
    this.abierto = true;
    this.animacion = "fadeInUp";
  }

  CerrarDialogo(respuesta : any)
  {
    this.animacion = "fadeOutDown";

    setTimeout(() =>
    {
      this.dialogoService.EnviarRespuestaDialogo(respuesta);
      this.icono = "";
      this.abierto = false;
      this.dialogo = new Dialogo();
    }, 310);

  }

  SetDatosDialogo(dialo : Dialogo)
  {
    switch (this.dialogo.Tipo)
    {
      case DialogoEnum.normal:
        break;

      case DialogoEnum.aviso:
        this.icono = "fa fa-warning";
        this.claseIcono = "aviso";
        break;

      default:
        break;
    }
  }

}
